<template>
  <div class="information-section">
    <b-row class="d-flex align-items-center mb-2 mt-1 px-2">
      <b-col>
        <span class="ap-title ap-title__main">{{ $tc('globalLocator.sections.sampleData') }}</span>
      </b-col>
    </b-row>

    <b-form-row class="px-2 pt-2">
      <b-col lg="8">
        <div class="info-card">
          <b-form-row class="h-100">
            <b-col class="flex-row-center">
              <section-info-col-type
                :label="$tc('globalLocator.labels.sampleType')"
                :data="sample.sampleType"
                col-class="flex-column-center"
              >
                <template #default="{ data }">
                  {{ data.description }}
                </template>
              </section-info-col-type>
            </b-col>
            <b-col
              cols="3"
              class="flex-row-center"
            >
              <section-info-col-type
                :label="$tc('globalLocator.labels.location')"
                :data="sample.topographicCode"
                col-class="flex-column-center"
              >
                <template #default="{ data }">
                  {{ data.description }}
                </template>
              </section-info-col-type>
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type
                :label="$tc('globalLocator.labels.laboratory')"
                :data="sample.currentLaboratory"
                col-class="flex-column-center"
              >
                <template #default="{ data }">
                  {{ data.labName }}
                </template>
              </section-info-col-type>
            </b-col>
          </b-form-row>
        </div>
      </b-col>
      <b-col lg="4">
        <div class="info-card">
          <b-form-row class="h-100">
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.productionDate')"
                :date="sample.samSamplingDate"
                col-class="flex-column-center"
              />
            </b-col>
            <b-col class="flex-row-center">
              <section-info-col-type-date
                :label="$tc('globalLocator.labels.grossingDate')"
                :date="sample.lastGrossingDate"
                col-class="flex-column-center"
              />
            </b-col>
          </b-form-row>
        </div>
      </b-col>
    </b-form-row>

    <b-row class="mt-4 px-2">
      <b-col cols="12">
        <b-row class="px-2">
          <b-col
            cols="4"
            class="my-2"
          >
            <section-info-col-type
              :label="$tc('globalLocator.labels.procedure')"
              :data="sample.procedureId"
            >
              <template #default="{ data }">
                {{ data.description }}
              </template>
            </section-info-col-type>
          </b-col>
          <b-col
            cols="4"
            class="my-2"
          >
            <section-info-col-type
              :label="$tc('globalLocator.labels.probableDiagnosis')"
              :data="sample.mostLikelyMorphologicCode"
            >
              <template #default="{ data }">
                {{ data.description }}
              </template>
            </section-info-col-type>
          </b-col>
          <b-col
            cols="4"
            class="my-2"
          >
            <section-info-col-type
              :label="$tc('globalLocator.labels.conservationMedium')"
              :data="sample.conservation"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-2">
      <b-col cols="12">
        <hr>
      </b-col>
    </b-row>

    <b-row class="mt-4 pt-1 px-2">
      <b-col
        class="py-3"
        cols="4"
      >
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.responsibleGrossing')"
          :personnel="sample.responsibleForGrossing"
        />
      </b-col>
      <b-col
        class="py-3"
        cols="4"
      >
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.nonPathologistSpecialist')"
          :personnel="sample.specialist"
        />
      </b-col>
      <b-col
        class="py-3"
        cols="4"
      >
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.grossingTutor')"
          :personnel="sample.grossingTutor"
        />
      </b-col>
      <b-col
        class="py-3"
        cols="4"
      >
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.controllerGrossing')"
          :personnel="sample.grossingControllerTechnician"
        />
      </b-col>
      <b-col
        v-if="isLiquidPhaseCytology"
        class="py-3"
        cols="4"
      >
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.processorEntryTechnician')"
          :personnel="sample.processingStartPersonnel"
        >
          <small class="dark">{{ sample.processingStartDate | datetime }}</small>
        </section-info-col-type-personnel>
      </b-col>
      <b-col
        v-if="isLiquidPhaseCytology"
        class="py-3"
        cols="4"
      >
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.processorDepartureTechnician')"
          :personnel="sample.processingEndPersonnel"
        >
          <small class="dark">{{ sample.processingEndDate | datetime }}</small>
        </section-info-col-type-personnel>
      </b-col>
      <b-col
        class="py-3"
        cols="4"
      >
        <section-info-col-type-personnel
          :label="$tc('globalLocator.labels.wasteTechnician')"
          :personnel="sample.wasteTechnician"
        >
          <small
            v-if="sample.disposalDate"
            class="dark"
          >
            {{ sample.disposalDate | datetime }}
          </small>
        </section-info-col-type-personnel>
      </b-col>
    </b-row>

    <b-row class="px-2 mt-2">
      <b-col cols="12">
        <hr>
      </b-col>
    </b-row>

    <b-row class="px-2">
      <b-col class="my-2">
        <section-info-col-type
          :label="$tc('globalLocator.labels.additionalData')"
          :data="sample.observations"
        />
      </b-col>
      <!-- TODO: Solo aparece si hay intercambio de elementos, en elementos que se puedan intercambiar -->
      <!--<b-col cols="12" class="my-2">
                <div class="data-card d-flex align-items-center">
                    <div class="data-card-text d-flex flex-column">
                        <small>{{$tc('exchanges.grid.originCenter')}}</small>
                        <span>anatomical pathology3</span>
                    </div>
                </div>
            </b-col>-->
    </b-row>
  </div>
</template>

<script>
import SectionInfoColType from '@/modules/globalLocatorModule/sections/info/col-types/section-info-col-type.vue'
import SectionInfoColTypeDate from '@/modules/globalLocatorModule/sections/info/col-types/date/section-info-col-type-date.vue'
import SectionInfoColTypePersonnel from '@/modules/globalLocatorModule/sections/info/col-types/personnel/section-info-col-type-personnel.vue'

export default {
    name: 'SampleInfoSection',
    components: {
        SectionInfoColType,
        SectionInfoColTypeDate,
        SectionInfoColTypePersonnel
    },
    props: {
        sample: { type: Object, required: true }
    },
    computed: {
        isLiquidPhaseCytology() {
            return (this.sample.sampleType.code === 'SAT015')
        }
    }
}
</script>
